export default __webpack_public_path__ + "media/images/services-10-370x250-ab2d58d36631155aaedc526c0cce7ce9.jpg";